import { useState } from 'react';
import ImplementationGuideModal from './ImplementationGuideModal';

export default function IntegrationHero() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-slate-50 via-blue-50 to-purple-50 overflow-hidden">
        {/* Background */}
        <div className="absolute inset-0 z-0">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20educational%20partnership%20concept%20with%20interconnected%20elements%2C%20academic%20collaboration%20visualization%20in%20warm%20orange%20and%20teal%20gradient%2C%20professional%20minimalist%20design%20with%20geometric%20patterns%20and%20depth%2C%20suitable%20for%20education%20technology%20website&width=1920&height=1080&seq=integration-hero-001&orientation=landscape"
            alt="Academic Integration Background"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-24 text-center">
          <div className="inline-flex items-center gap-2 px-5 py-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-full mb-7 shadow-lg">
            <i className="ri-calendar-check-line text-teal-400 text-base"></i>
            <span className="text-white text-xs font-medium">
              Structured 12-Month Partnership Model
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl font-bold text-white mb-5 leading-tight">
            Complete Academic Integration<br />
            <span className="text-teal-400">From Planning to Excellence</span>
          </h1>

          <p className="text-base md:text-lg text-gray-200 mb-10 max-w-3xl mx-auto leading-relaxed">
            A comprehensive roadmap for seamless STEM integration with quarterly milestones, continuous support, and measurable outcomes
          </p>

          <div className="flex flex-wrap items-center justify-center gap-4 mb-10">
            <a
              href="#roadmap"
              className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white text-sm font-semibold rounded-lg hover:from-blue-700 hover:to-purple-700 transition-all shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-map-2-line text-base"></i>
              View 12-Month Roadmap
            </a>
          </div>

          {/* Key Benefits */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-5 mt-12 max-w-4xl mx-auto">
            {[
              { icon: 'ri-calendar-line', text: 'Structured Timeline' },
              { icon: 'ri-team-line', text: 'Dedicated Support' },
              { icon: 'ri-line-chart-line', text: 'Measurable Outcomes' },
              { icon: 'ri-refresh-line', text: 'Continuous Improvement' }
            ].map((benefit, idx) => (
              <div key={idx} className="bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-4 hover:bg-white/20 transition-all">
                <i className={`${benefit.icon} text-2xl text-teal-400 mb-2 block`}></i>
                <p className="text-white text-sm font-semibold">{benefit.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <ImplementationGuideModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </>
  );
}
